var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtoncopy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FBB982"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3006_11743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 19.5H21.1667C20.2462 19.5 19.5 20.2462 19.5 21.1667V28.6667C19.5 29.5871 20.2462 30.3333 21.1667 30.3333H28.6667C29.5871 30.3333 30.3333 29.5871 30.3333 28.6667V21.1667C30.3333 20.2462 29.5871 19.5 28.6667 19.5Z",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 24.4993H15.3334C14.8914 24.4993 14.4675 24.3238 14.1549 24.0112C13.8423 23.6986 13.6667 23.2747 13.6667 22.8327V15.3327C13.6667 14.8907 13.8423 14.4667 14.1549 14.1542C14.4675 13.8416 14.8914 13.666 15.3334 13.666H22.8334C23.2754 13.666 23.6994 13.8416 24.0119 14.1542C24.3245 14.4667 24.5001 14.8907 24.5001 15.3327V16.166",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3006_11743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtoncopy2);
export default __webpack_public_path__ + "static/media/Buttoncopy2.84df338fbe691ddca72a14817f88e82c.svg";
export { ForwardRef as ReactComponent };